import { currencies, Divider, useCurrencyCodeConverter } from '@treezor/design-system';

import { useI18nLocale } from '@/hooks/useI18nLocale';
import { ITransactionByDigitizedCard } from '@/features/cards/store/models/card.model';

export interface IPaymentAmountCellProps {
  transaction: ITransactionByDigitizedCard;
}

export function PaymentAmountDetail({ transaction }: IPaymentAmountCellProps) {
  const { convertCurrencyToCode } = useCurrencyCodeConverter();
  const locale = useI18nLocale();

  const decode = (html?: string) => {
    if (!html) return '';
    const el = document.createElement('textarea');
    el.innerHTML = html;
    return el.value;
  };

  const hasLocalAmount = !!transaction?.paymentCurrency && transaction.paymentCurrency !== transaction?.walletCurrency;
  const walletSymbol = decode(
    currencies.find((c) => c.abbreviation === convertCurrencyToCode(transaction?.walletCurrency))?.symbol,
  );
  const transactionSymbol = decode(
    currencies.find((c) => c.abbreviation === convertCurrencyToCode(transaction?.paymentCurrency))?.symbol,
  );

  return (
    <div className="flex flex-col items-center justify-end gap-2">
      <span className="text-secondary typo-h5-bold">
        {`${walletSymbol} 
        ${Intl.NumberFormat(locale.length > 2 ? `${locale.slice(0, 2)}-${locale.slice(2)}` : locale).format(
          Number(transaction.paymentAmount),
        )}`}
      </span>
      {hasLocalAmount && (
        <>
          <Divider length="12px" thickness="100" />
          <span className="typo-body-regular-caption text-tertiary">
            {`${transactionSymbol ?? ''} 
            ${Intl.NumberFormat(locale.length > 2 ? `${locale.slice(0, 2)}-${locale.slice(2)}` : locale).format(
              Number(transaction.paymentLocalAmount),
            )} 
            (${convertCurrencyToCode(transaction.paymentCurrency)})`}
          </span>
        </>
      )}
    </div>
  );
}
